// Module
var code = "<postal-address id=\"{{ componentId }}\" ng-attr-name=\"{{ componentId }}\" ng-model=\"data[component.key]\" options=\"component.kdata.options\" placeholder=\"{{ component.placeholder | translate }}\" ng-disabled=\"readOnly || component.disabled\"></postal-address> ";
// Exports
export default code;